export const catalogs = {
  accountType: 'account-type',
  transactionType: 'transaction-type',
  personTypes: 'person-types',
  countries: 'countries',
  politicalDivisions: 'political-divisions',
  periodicityType: 'periodicity-types',
  rateType: 'rate-types',
  formCellSections: 'form-cell-sections',
  inboxTypes: 'inbox-types',
  inboxTypesTaxOfficer: 'inbox-types-tax-officer',
  taxReturnCurrencies: 'taxreturn-currencies',
  paymentMethod: 'payment-method',
  taxCollector: 'tax-collector'
};
